import React from 'react'
import { FormattedMessage } from 'react-intl'

import Review from 'js/components/Review'
import { shuffleArray } from 'js/utils'

import messages from './messages'

const reviews = [...Array(7).keys()].map((i) => (
  <FormattedMessage key={`review${i}`} {...messages[`review${i + 1}`]} />
))

function Reviews() {
  const shuffledReview = shuffleArray(reviews)
  return (
    <div className="grid gap-8 md:grid-cols-3">
      <Review rating={5} text={shuffledReview[0]} />
      <Review rating={5} text={shuffledReview[1]} />
      <Review rating={5} text={shuffledReview[2]} />
    </div>
  )
}

export default Reviews
